import type { ReactNode } from 'react';

/**
 * Shell compartilhado das páginas de auth (login / esqueci / reset) — padrão
 * CLARO do checkout dos sites (fundo branco, card com borda suave, logo azul,
 * ações em navy-primary #0D1580). Vive fora do AuthGuard/TraderLayout, então
 * não afeta o app logado; `.force-light` (index.css) fixa as CSS vars claras
 * mesmo com html.dark ativo — funciona igual nos dois temas e no mobile.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="force-light flex min-h-screen items-center justify-center bg-white px-6 py-12">
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <img src="/brand/pnl-logo-blue.png" alt="PnL Global" className="mx-auto h-9 w-auto" />
          <p className="text-ink-500 text-2xs mt-1.5 font-semibold uppercase tracking-widest">
            Área do Trader
          </p>
        </div>
        <div className="border-ink-800 bg-ink-900 shadow-soft rounded-2xl border p-6 sm:p-8">
          {children}
        </div>
      </div>
    </div>
  );
}
